import MapModalContainer from "../../../components/property/map/MapModal";

const MapModal = () => {
  return <MapModalContainer />;
};

export default MapModal;
